import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Checkbox from '@material-ui/core/Checkbox';
import Text from '../../../../shared/components/Text/Text';

// Custom checkbox icons
const CustomUncheckedIcon = () => (
  <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect x='0.5' y='0.5' width='17' height='17' rx='1.5' stroke='#E0E0E0' />
  </svg>
);

const CustomCheckedIcon = () => (
  <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect x='0.5' y='0.5' width='17' height='17' rx='1.5' fill='white' stroke='#77A7FF' />
    <path d='M5 9L8 12L13 6' stroke='#77A7FF' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);

const AthleteItemDiv = styled('div')`
  display: flex;
  align-items: center;
  cursor: ${({ isFake }) => (isFake ? 'default' : 'pointer')};
  font-family: 'Nunito Sans';
  font-size: 16px;
  color: #444444;
  border-radius: 4px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${({ isFake }) => (isFake ? 'transparent' : '#f8f8f8')};
  }
`;

const StyledCheckbox = styled(Checkbox)`
  padding: 4px;
  margin-right: 12px;

  &:hover {
    background-color: rgba(119, 167, 255, 0.04);
  }
`;

const AthleteName = styled('div')`
  flex: 1;
  font-weight: 500;
  font-size: 16px;
  color: #444444;
  margin-left: ${({ hasCheckbox }) => (hasCheckbox ? '0' : '34px')};
`;

const SimpleAthleteItem = ({
  athlete,
  isChecked,
  onCheckboxChange,
}) => {
  const isFakeAthlete = athlete.fake;

  const handleCheckboxClick = (e) => {
    e.stopPropagation();
    if (!isFakeAthlete) {
      onCheckboxChange(athlete.id, !isChecked);
    }
  };

  return (
    <AthleteItemDiv
      onClick={isFakeAthlete ? undefined : handleCheckboxClick}
      id={athlete.id}
      isFake={isFakeAthlete}
    >
      {!isFakeAthlete && (
        <StyledCheckbox
          checked={isChecked}
          onChange={handleCheckboxClick}
          icon={<CustomUncheckedIcon />}
          checkedIcon={<CustomCheckedIcon />}
        />
      )}
      <AthleteName hasCheckbox={!isFakeAthlete}>
        <Text>
          {`${athlete.first} ${athlete.last}`}
        </Text>
      </AthleteName>
    </AthleteItemDiv>
  );
};

SimpleAthleteItem.propTypes = {
  athlete: PropTypes.instanceOf(Object).isRequired,
  isChecked: PropTypes.bool,
  onCheckboxChange: PropTypes.func.isRequired,
};

SimpleAthleteItem.defaultProps = {
  isChecked: false,
};

export default SimpleAthleteItem;
